export type DateRange = {
  minDate?: string;
  maxDate?: string;
};

export type FormattedDateRangeItem = Required<{
  [Property in keyof DateRange]: {
    value: string;
    error: string;
  };
}>;

export type FormattedDateRange = {
  isSharedError: boolean;
} & FormattedDateRangeItem;

export const getInitialDateRange = (): FormattedDateRange => ({
  minDate: { value: '', error: '' },
  maxDate: { value: '', error: '' },
  isSharedError: false,
});

export const DATE_FORMAT = {
  yyyy: 'yyyy',
  YYYY: 'YYYY',
};
